import { getSchema } from "./schemas/getSchema";
import { Timestamp } from "firebase/firestore";

export default function setupEdit(item, tableName) {
  const schema = getSchema(tableName);
  const schemaFields = schema.map((f) => f.name);

  schema.forEach((fd) => {
    if (
      fd.type === "date" &&
      fd.name !== "Modified Date" &&
      fd.name !== "Created Date" &&
      item[fd.name].hasOwnProperty("seconds")
    ) {
      item[fd.name] = new Timestamp(item[fd.name].seconds, 0)
        .toDate()
        .toISOString()
        .split("T")[0];
    }
  });

  for (const key in item) {
    if (key !== "Selected" && !schemaFields.includes(key)) {
      schema.push({
        name: key,
        default: "",
        type: typeof item[key],
        maxLength:
          item[key].toString().length < 255 ? 255 : item[key].toString().length,
        selectables: [],
        similair: [],
        helperText: "",
        nullable: true,
        readOnly: false,
        error: false,
      });
    }
  }
  return { item, schema };
}
